export default __webpack_public_path__ + "static/media/ikon-linkedin.27a3f479.svg";